import { useState } from 'react';
import {
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  NavRight,
  Link
} from 'framework7-react';
import 'firebase/compat/auth';
import '../styles/login.css';
import {
  changePassword,
  getChangePasswordErrorMessage,
} from '../firebase';

import { f7 } from 'framework7-react';
import '@styles/change-password.css';
import PasswordInput from './PasswordInput';


function ChangePasswordPage() {
  const [current, setCurrent] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const isLengthValid = password.length >= 8;
  const hasNumber = /\d/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const doPasswordsMatch = password === confirm;

  const canSave = Boolean(
    current &&
    isLengthValid &&
    hasNumber &&
    hasUppercase &&
    doPasswordsMatch &&
    !isSaving
  );

  const handleSave = async () => {
    if (isSaving) return;
    if (!doPasswordsMatch) {
      f7.dialog.alert('New passwords do not match.');
      return;
    }
    if (!canSave) return;

    setIsSaving(true);
    try {
      await changePassword(current, password);
      f7.dialog.alert('Password updated successfully.');
      f7.views.main.router.back();
    } catch (error: unknown) {
      const errorCode =
        error && typeof error === 'object' && 'code' in error
          ? String(error.code)
          : 'unknown';
      console.error('Password update failed', { code: errorCode });
      f7.dialog.alert(getChangePasswordErrorMessage(error));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Page name="change-password">
      <Navbar className="no-outline">
        <NavLeft>
          <Link back className="cancel-button">Cancel</Link>
        </NavLeft>
        <NavTitle>Change password</NavTitle>
        <NavRight>
          <Link
            className={`save-button ${canSave ? '' : 'disabled'}`}
            onClick={handleSave}
          >
            {isSaving ? 'Saving\u2026' : 'Save'}
          </Link>
        </NavRight>
      </Navbar>

      <form className="login-form change-password-form" onSubmit={(e) => e.preventDefault()}>
        <label htmlFor="current-password">Current password</label>
        <PasswordInput
          id="current-password"
          placeholder="Enter current password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          required
        />

        <label htmlFor="new-password">New password</label>
        <PasswordInput
          id="new-password"
          placeholder="Enter a password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <label htmlFor="confirm-password">Confirm new password</label>
        <PasswordInput
          id="confirm-password"
          placeholder="Enter a password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
        />
      </form>

      <div className="password-rules">
        <p className={isLengthValid ? 'valid' : 'invalid'}>
          {isLengthValid ? '✓' : '✗'} Must be 8 characters long
        </p>
        <p className={hasNumber ? 'valid' : 'invalid'}>
          {hasNumber ? '✓' : '✗'} Contain a number
        </p>
        <p className={hasUppercase ? 'valid' : 'invalid'}>
          {hasUppercase ? '✓' : '✗'} Contain an uppercase
        </p>
        <p className={doPasswordsMatch ? 'valid' : 'invalid'}>
          {doPasswordsMatch ? '✓' : '✗'} Passwords must match
        </p>
      </div>
    </Page>
  );
}

export default ChangePasswordPage;
